// Constants
import { makeStyles, tokens } from "@fluentui/react-components";
import { HeaderPadding } from "@ms/planner-generic-controls/lib/local/constants/StyleConstants";
import { flexParent, responsiveBreakpoint } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
/**
 * Styles for UserViewHeader
 */ export const useUserViewHeaderStyles = makeStyles({
    pageTitle: {
        ...flexParent(),
        alignItems: "center"
    },
    pageLinks: {
        ...flexParent(),
        alignItems: "center",
        paddingLeft: HeaderPadding,
        columnGap: tokens.spacingHorizontalSNudge,
        "& .diamondButton": {
            margin: "0px"
        },
        ...responsiveBreakpoint("xsmall", {
            paddingLeft: tokens.spacingHorizontalSNudge
        })
    },
    title: {
        fontSize: tokens.fontSizeBase400,
        fontWeight: tokens.fontWeightBold,
        color: tokens.colorNeutralForeground1,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    },
    iconWrapper: {
        height: tokens.spacingVerticalXL,
        width: tokens.spacingHorizontalXL,
        marginRight: tokens.spacingHorizontalS,
        color: tokens.colorNeutralForeground1
    }
});
